import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-521fbc02")

_pushScopeId("data-v-521fbc02")
const _hoisted_1 = { class: "w-full pt-2 pb-4 px-4 h-full bg-gray-lp-1200" }
const _hoisted_2 = { class: "bg-white w-full h-full rounded-xl p-4" }
const _hoisted_3 = { class: "justify-self-end ml-auto" }
const _hoisted_4 = {
  key: 1,
  class: "cargo-table"
}
const _hoisted_5 = { class: "flex flex-col items-start break-all text-left" }
const _hoisted_6 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_11 = { class: "flex items-center gap-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_CargoV2FilterSection = _resolveComponent("CargoV2FilterSection")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WidgetDownloadCargo = _resolveComponent("WidgetDownloadCargo")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_CargoV2FilterSection, {
        summary: {},
        initialFilter: _ctx.localFilter,
        isSuccessBookingTab: false,
        onSearch: _ctx.onSearch,
        onChange: _ctx.onFilterChange
      }, {
        actions: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_lp_button, {
              title: _ctx.$t('cargo.filters.downloadFailedList'),
              outline: "",
              textColor: "red-lp-100",
              iconLeft: "download-new",
              sizeIcon: "14px",
              onClick: _ctx.onDownloadFailedList
            }, null, 8, ["title", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["initialFilter", "onSearch", "onChange"]),
      (_ctx.cargoListAvailable)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            customMessage: _ctx.$t('cargo.messages.noData')
          }, null, 8, ["customMessage"]))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.cancelledList,
              loading: _ctx.isLoading,
              pagination: _ctx.cancelledPagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelledPagination = $event)),
              paginationStyle: "v3",
              onRequest: _ctx.fetchList,
              errorCause: _ctx.errorCause,
              isDetailAble: true,
              onClick: _ctx.onClickRow,
              bgHeader: "bg-white border-b border-gray-lp-200",
              paginationV3PaddingVertical: "py-4",
              customClassPagination: "absolute w-full bottom-4 right-0 left-0 -mb-4 px-8",
              paginationWidth: "cargo-tab-booking-success-pagination",
              isNoPaddingBottom: "",
              isTabList: true
            }, {
              no_booking: _withId(({ item }) => [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.displayBookingNo(item)), 1)
              ]),
              origin_destination: _withId(({ item }) => [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.originCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.originCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ]),
                    _hoisted_8,
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.destinationCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  (item.cargoType === 'plane')
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportOriginCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _hoisted_10,
                        _withDirectives(_createVNode("span", null, [
                          _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            item.airportDestinationCityName,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              atur_cancel_booking: _withId(({ item }) => [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_lp_button, {
                    onClick: 
                  (e) => {
                    e.stopPropagation();
                    _ctx.openModalReBooking(item);
                  }
                ,
                    title: _ctx.$t('cargo.actions.rebook'),
                    outline: "",
                    textColor: "red-lp-100"
                  }, null, 8, ["onClick", "title"]),
                  _createVNode("img", {
                    class: "cursor-pointer w-5 h-5",
                    src: _imports_0,
                    alt: _ctx.$t('cargo.actions.delete'),
                    onClick: 
                  (e) => {
                    e.stopPropagation();
                    _ctx.openModalDelete(item);
                  }
                
                  }, null, 8, ["alt", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "onClick"])
          ])),
      _withDirectives(_createVNode(_component_Modal, {
        onSubmit: _ctx.confirmDelete,
        onClose: _ctx.closeModalDelete,
        title: _ctx.$t('cargo.messages.deleteBookingTitle'),
        message: _ctx.deleteModalMessage,
        image: "badge-confirmation-general",
        textSuccess: _ctx.$t('cargo.actions.yesDelete'),
        textCancel: _ctx.$t('cargo.actions.cancel'),
        class: "px-8"
      }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
        [_vShow, _ctx.showModalDelete]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onSubmit: _ctx.goToReBooking,
        onClose: _ctx.closeModalReBooking,
        title: _ctx.$t('cargo.messages.rebookBookingTitle'),
        message: _ctx.rebookModalMessage,
        image: "badge-confirmation-general",
        textSuccess: _ctx.$t('cargo.actions.yesRebook'),
        textCancel: _ctx.$t('cargo.actions.cancel'),
        class: "px-8"
      }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
        [_vShow, _ctx.showModalReBooking]
      ])
    ]),
    _createVNode(_component_WidgetDownloadCargo, { type: "retry-cargo-failed-report" })
  ]))
})